<template>
  <div class="stock-wrap" key="1">
    <div class="search-hd clear">
      <el-form :inline="true" @submit.native.prevent class="form-screen">
        <!-- 导出excel -->
        <!-- <el-form-item style="float: right; margin-right: 0" v-if="funcView.export_stock">
          <el-button class="table-set" style="vertical-align: top"><i class="icon icon-daochu"></i></el-button>
        </el-form-item> -->
        <el-form-item v-if="funcView.operations_add">
          <el-button class="custom-btn" icon="icon icon-tianjia left-icon" type="warning" round @click="onCreateReport()">{{ $t('operations.scywbg') }}</el-button>
        </el-form-item>
        <el-form-item style="float: right; margin-right: 0">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <i class="icon icon-shaixuan icon-filter" @click="isFilter = !isFilter"></i>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input :placeholder="$t('operations.gong_si_ming_cheng')" v-model="formSearch.orgName" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
      </el-form>
      <div class="query-filter" v-show="isFilter">
      <div class="params-form">
        <el-row :gutter="23">
          <el-col :span="8">
            <div class="item">
              <div class="label">{{ $t('operations.sheng_cheng_shi_jian') }}</div>
              <div class="value">
                <custom-date-picker
                  v-model="formSearch.genDateRange"
                  type="daterange"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  :picker-options="beforeToday"
                  :start-placeholder="$t('Common.com_start_date')"
                  :end-placeholder="$t('Common.com_end_date')"
                  @change="onPageChange({ page: 1 })"
                ></custom-date-picker>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="filter-values">
        <div class="label">{{ $t('Common.com_filter_item') }}</div>
        <div class="values">
          <el-tag v-if="genDateRangeLabel" closable @close="clearGenDateRange">{{ genDateRangeLabel }}</el-tag>
          <span class="clear" @click="onClear">{{ $t('Common.com_clear') }}</span>
        </div>
      </div>
      </div>
    </div>
    <div class="table-card">
      <div class="table-bd">
        <custom-table
          height="100%"
          :index="true"
          :stripe="true"
          :data="tableList"
          :slots="['realName', 'action']"
          tableCode="portal_operations_list"
          @sort="sortChange"
          @filter="filterChange"
          @column="setColumn"
        >
          <template slot="realName" slot-scope="scope">
            {{ scope.row.realname || '-' }} / {{ scope.row.userName || '-' }}
          </template>
          <template slot="action" slot-scope="scope">
            <el-button v-if="funcView.operations_download && +scope.row.reportGenState === 2" type="text" size="mini" @click="onDownload(scope.row)">{{ $t('operations.xia_zai') }}</el-button>
            <el-button v-if="funcView.operations_email && +scope.row.reportGenState === 2" type="text" size="mini" @click="onOpenEmailDialog(scope.row)">{{ $t('operations.you_jian') }}</el-button>
            <el-button v-if="funcView.operations_retry && +scope.row.reportGenState === 4" type="text" size="mini" @click="onRetry(scope.row)">{{ $t('operations.chong_shi') }}</el-button>
          </template>
        </custom-table>
      </div>
      <div class="table-footer">
        <custom-pagination radius :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-pagination>
      </div>
    </div>

    <work-report-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onReportSuccess"></work-report-dialog>
    <operations-email-dialog v-if="dialogVisible2" :model="dialogModel2" @close="dialogVisible2 = false" @success="onEmailSuccess"></operations-email-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import moment from 'moment';
import workReportDialog from './operations_report_dialog.vue';
import operationsEmailDialog from './operations_email_dialog.vue';

export default {
  name: 'operations',
  mixins: [],
  components: {
    workReportDialog,
    operationsEmailDialog,
  },
  props: {},
  data() {
    return {
      tableSelect: [],
      isFilter: false,
      formSearch: {
        orgName: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,
        genDateRange: [
          this.$momentWorld(moment(this.$getLocalTime()).startOf('month').format('YYYY-MM-DD 00:00:00')),
          this.$momentWorld(moment(this.$getLocalTime()).format('YYYY-MM-DD 23:59:59')),
        ],
      },
      tableList: [],
      totalRows: 0,
      dialogVisible: false,
      dialogModel: {},
      dialogVisible2: false,
      dialogModel2: {},
    };
  },
  computed: {
    genDateRangeLabel() {
      if (!this.formSearch.genDateRange || this.formSearch.genDateRange.length < 2) {
        return '';
      }
      const start = this.$momentLocal(this.formSearch.genDateRange[0], 'YYYY-MM-DD');
      const end = this.$momentLocal(this.formSearch.genDateRange[1], 'YYYY-MM-DD');
      return `${start} - ${end}`;
    },
  },
  watch: {},
  filters: {},
  directives: {},
  methods: {
    onCreateReport() {
      this.dialogModel = {
        title: this.$t('operations.scywbg'),
        data: {},
      };
      this.dialogVisible = true;
    },
    getTableList() {
      this.syncGenTimeRange();
      const reqData = {
        ...this.formSearch,
      };
      delete reqData.genDateRange;
      this.$getJSON(apis.workReportPage, reqData).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    clearGenDateRange() {
      this.formSearch.genDateRange = [];
      this.onPageChange({ page: 1 });
    },
    onClear() {
      this.clearGenDateRange();
    },
    syncGenTimeRange() {
      if (!this.formSearch.genDateRange || this.formSearch.genDateRange.length < 2) {
        this.formSearch.genStartDate = '';
        this.formSearch.genEndDate = '';
        return;
      }
      this.formSearch.genStartDate = this.formSearch.genDateRange[0];
      this.formSearch.genEndDate = this.formSearch.genDateRange[1];
    },
    onReportSuccess() {
      this.dialogVisible = false;
      this.getTableList();
    },
    onEmailSuccess() {
      this.dialogVisible2 = false;
    },
    onDownload: function (row) {
      this.$getFileList({
        bizId: row.genRecordId,
        bizType: 'ras.generate',
      }).then((list) => {
        list.forEach((item) => {
          this.$downloadFile(this.getAttachUrl(item), item.attachName);
        });
      });
    },
    onOpenEmailDialog(row) {
      this.dialogModel2 = {
        title: this.$t('operations.fa_song_bao_gao'),
        data: {
          genRecordId: row.genRecordId,
          email: row.pushEmail || '',
        },
      };
      this.dialogVisible2 = true;
    },
    onRetry(row) {
      this.$postJSON(`${apis.workReportRetry}/${row.genRecordId}`, {}, true).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.getTableList();
      });
    },
  },
  created() {},
  mounted() {
    this.getTableList();
    this.getFuncView();
  },
};
</script>

<style lang="scss">
</style>
